<template>
  <div v-show="!(isAvailable || isDisabled)">
    <img
      loading="lazy"
      src="@/assets/images/warning-red.svg"
      width="35"
      height="35"
      data-test="warning-red-2"
    />
    <translate
      v-if="isMinNights || chargetype.availAfterMinStay"
      :tt="{ minDays: chargetype.minDays }"
    >
      Minimum night stay applies ({minDays} nights)
    </translate>
    <span
      v-else-if="
        isMaxCapacity && chargetype.isOvercapacityMessage && dogsExceed
      "
    >
      {{ chargetype.isOvercapacityMessage }}
    </span>
    <translate v-else-if="isMaxCapacity" :tt="{ capacity }">
      Your party size exceeds the maximum persons for this pitch ({capacity}
      people)
    </translate>
    <translate v-else-if="isAdultsOnly"> Adults only </translate>
    <span v-else-if="chargetype.isOvercapacityMessage">
      {{ chargetype.isOvercapacityMessage }}
    </span>
    <translate v-else data-test="no-availability-on-our-site-1">
      No availability on our site
    </translate>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { ChargeType } from '../../../../campsite-details/types'

@Component
class AvailabilityErrorState extends Vue {
  @Prop()
  chargetype: ChargeType

  @Prop()
  capacity: number

  get isAvailable() {
    return this.chargetype.state === 'available'
  }

  get isDisabled() {
    return this.chargetype.state === 'disabled'
  }

  get isMinNights() {
    return this.chargetype.state === 'min_nights'
  }

  get isMaxCapacity() {
    return this.chargetype.state === 'max_capacity'
  }

  get isAdultsOnly() {
    return this.chargetype.state === 'adults_only'
  }

  get dogsExceed() {
    return this.chargetype.dogsExceed
  }
}

export default toNative(AvailabilityErrorState)
</script>
